module.exports = __webpack_public_path__ + "grip.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/grip.svg?color1=%23333333&color2=
// module id = 913
// module chunks = 67